import { useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import { toast, Toaster } from "react-hot-toast";
import ajaxAccounting from "../../util/remote/ajaxAccounting";
import Select from "react-select";

const InvoicablesUpdater = (props) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(props.data.name);
  const [unit, setUnit] = useState(props.data.unit);
  const [id, seId] = useState(props.data.id);
  const handleAdd = async (e, controls) => {
    e.preventDefault();
    if (name.trim() === "" || unit === "") {
      toast.error("Please complete all fields.");
    } else {
      setLoading(true);

      var data = {
        ID: id,
        name: name,
        unit: unit,
      };
      const server_response = await ajaxAccounting.updateInvoicableItem(data);

      setLoading(false);
      if (server_response.status === "OK") {
        toast.success(server_response.message);

        props.function();
        controls.close();
      } else {
        toast.error(server_response.message);
      }
    }
  };

  const RenderFooter = (controls) => {
    if (loading) {
      return <Loader />;
    } else {
      return (
        <>
          <button
            className="btn ripple btn-dark"
            type="button"
            onClick={controls.close}>
            Close
          </button>
          <button
            type="button"
            disabled={loading}
            className={`btn ripple btn-success`}
            onClick={(e) => handleAdd(e, controls)}>
            Save item
          </button>
        </>
      );
    }
  };

  return (
    <SystemModal
      title="Update Cost Allocation center"
      id="model-new-ledger"
      size="md"
      footer={RenderFooter}>
      <Toaster />
      <div className="mb-4 col-md-12">
        <label htmlFor="">
          Cost Allocation item:<span className="tx-danger">*</span>
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="form-control"
          placeholder="item Name"
        />
      </div>
      <div className="mb-4 col-md-12">
        <label htmlFor="">
          Cost Allocation item:<span className="tx-danger">*</span>
        </label>
        <input
          type="text"
          value={unit}
          onChange={(e) => setUnit(e.target.value)}
          className="form-control"
          placeholder="item Unit"
        />
      </div>
    </SystemModal>
  );
};

export default InvoicablesUpdater;
